// Format date to YYYY-MM-DD without timezone issues
export const formatDateToYYYYMMDD = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

// Format the date and time for Calendly URL
export const formatDateForCalendly = (date: string, time: string) => {
    // The time string is already an ISO datetime from the API (e.g. "2026-03-16T16:30:00+00:00")
    // Pass it through directly to preserve the original timezone offset
    return time;
};

// Format phone number for Calendly (remove spaces and ensure it starts with +)
export const formatPhoneNumber = (phone: string) => {
    if (!phone) return '';
    // Remove all spaces and ensure it starts with +
    return phone.replace(/\s+/g, '').replace(/^0/, '+39');
}; 